import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { useUpdateAvailable } from '~hooks/useUpdateAvailable';

import './style.scss';

// Routes where an interruption could cost the user work, so we hold the prompt
// back unless the update is forced.
const isCriticalFlow = (pathname) => pathname.startsWith('/intake/') || pathname.startsWith('/payment/process');

const UpdateBanner = () => {
  const { updateAvailable, forced, applyUpdate } = useUpdateAvailable();
  const { pathname } = useLocation();
  const intl = useIntl();

  if (typeof window === 'undefined' || !updateAvailable) {
    return null;
  }

  // A forced update always shows; otherwise we stay out of the way during
  // critical flows.
  if (!forced && isCriticalFlow(pathname)) {
    return null;
  }

  const handleRefresh = () => applyUpdate();

  return (
    <div className="c-update-banner" role="alert">
      <p className="c-update-banner__message">
        {intl.formatMessage({
          id: 'components.update-banner.message',
          defaultMessage: 'A new version of the site is available.',
        })}
      </p>
      <div className="c-update-banner__actions">
        <button type="button" className="c-update-banner__refresh" onClick={handleRefresh}>
          {intl.formatMessage({ id: 'components.update-banner.refresh', defaultMessage: 'Refresh' })}
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
